import { TicketManagement } from './TicketManagement';

interface AtendimentosManagementProps {
  initialTicketId?: string | null;
}

export function AtendimentosManagement({ initialTicketId }: AtendimentosManagementProps = {}) {
  return <TicketManagement initialTicketId={initialTicketId} />;
}
